import * as React from 'react';
import { DataSignal } from 's-js';
import SuperCritical from 'lib/supercritical';
import { Error, Errors } from 'lib/validationWatcher';
import { noDefault } from 'lib/eventWrappers';
import { PCModal } from 'portcall/pcmodal/view';

export const ValidationErrorView = SuperCritical(({ error } : { error : () => Error | undefined }) =>
    <div>
        {error() &&
            <div className="validationerror alert alert-danger">{error()!.ErrorText}</div>
        }
    </div>
);

/**
 * Alternate "lighter" validation error display. Inline by default (though of course you can
 * apply display: block or display: inline-block in your .less to override). Displays w/o
 * the surrounding background color or border of ValidationErrorView.
 */
export const LightErrorView = SuperCritical(({ error } : { error : () => Error | undefined }) =>
    <span className="validationerror-light">
        {error()?.ErrorText}
    </span>
);

export const ErrorModal = SuperCritical(({ errors, shown, title } : { errors : () => Errors, shown : DataSignal<boolean>, title : string }) =>
    <PCModal className="validationerror-modal" shown={shown} onBackDropClick={() => shown(false)}>
        <div className="modal-content pc-card profile-body">
            <div className="pc-card-header pc-card-title">
                <span>{title}</span>
                <a href="" onClick={noDefault(() => shown(false))}>Close</a>
            </div>
            <div className="modal-body">{ListErrors(errors())}</div>
        </div>
    </PCModal>
);

export function ListErrors(errors : Errors) {
    return Object.values(errors).map(err => err.ErrorTexts.map((text, i) =>
        <div key={`${err.Field}-${i}`} className="alert alert-warning">{text}</div>
    ));
}



// WEBPACK FOOTER //
// ./apps/core/validationerror/view.tsx